
const solicitudesState = {
  isLoading: false,
  solicitudes: null,
  companyRutError: null,
  rolesCurrentUser: [],
  roles: null,
  grupos: [
    { Name: "grupo1", Id: 1 },
    { Name: "grupo2", Id: 2 },
    { Name: "grupo3", Id: 3 },
  ],
}

export default solicitudesState;
